module.exports = "/_next/static/images/9692af4f481bd73e689fc84604976785-mgm-xs.jpg.webp";